<template>
  <div v-if="role == 'super_admin'" >
    <p class="mb-0 mr-2 text-primary">
      <b-button
          variant="outline-primary"
          class="font-weight-bolder cursor-pointer"
          @click="clickBadge()"
      >{{ nameClient }}</b-button>
      <b-link :to="{ name: 'createClient' }">
        <b-button
            v-if="role == 'super_admin'"
            variant="primary"
            size="sm"
            class="ml-1"
        >
          Añadir cliente
        </b-button>
      </b-link>
    </p>
    <modal-clients
        v-if="canChangeClient"
    />
  </div>
</template>

<script>
import { BBadge, BButton, BLink } from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from "vuex";
import modalClients from "@/components/clients/ModalClients.vue";

export default {
  components: {
    BLink,
    BBadge,
    BButton,
    modalClients,
  },
  data() {
    return {
      canChangeClient: false,
      chargeList: false,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: "clients/getCurrentClient",
      listClients: "clients/getListClients",
      role: "auth/getRole",
      currentUser: "auth/getUser",
    }),
    nameClient() {
      if (this.currentClient) {
        return this.currentClient.name;
      }
      return 'Seleccionar cliente';
    },
  },
  watch: {
    async currentCompany() {
      await this.searchClients({
        page: 1,
        per_page: 10,
        search: this.stringSearchClient,
      }).then(() => {
        this.checkList();
      });
    },
  },
  methods: {
    ...mapActions({
      searchClients: "clients/searchClients",
      getListClients: "clients/getListClients",
    }),
    ...mapMutations({
      setShowModalClients: "clients/setShowModalClients",
      setCurrentClient: "clients/setCurrentClient",
    }),
    checkList() {
      console.log(this.currentUser);
      if (this.currentUser.clients?.length === 1) {
        if (this.role !== "super_admin") {
          if (!this.currentClient) {
            this.setCurrentClient(this.currentUser.clients[0]);
            this.canChangeClient = false;
          } else {
            this.canChangeClient = false;
          }
        } else {
          this.canChangeClient = true;
        }
      } else if (
        this.listClients.length > 1 ||
        this.role === "super_admin"
      ) {
        this.canChangeClient = true;
      } else if (!this.currentClient && this.role !== "admin_empresa") {
        this.setCurrentClient(this.listClients[0]);
      }
    },
    async clickBadge() {
      if (this.canChangeClient) {
        if (!this.chargeList) {
          await this.getListClients({
            page: 1,
            per_page: 10,
            search: this.stringSearchClient,
          })
            .then(() => {
              this.checkList();
              this.chargeList = true;
              if (this.canChangeClient) {
                this.setShowModalClients(true);
              }
            });
        } else if (this.canChangeClient) {
          this.setShowModalClients(true);
        }
      }
    },
  },
  async created() {
    this.chargeList = true;
    if (this.role == 'super_admin') {
      await this.getListClients({
        page: 1,
        per_page: 10,
        search: this.stringSearchClient,
      })
      .then(() => {
        this.checkList()
      })
    }
  },
};
</script>
